module.exports = __webpack_public_path__ + "static/random-jokes-7a02785b23799d09e3c634b47ffef21e.gif";